export const environment = {
    production: false,
    baseUrl: "https://bp-dev-apim.azure-api.net/pf-dev/",
    baseUrlRbac: "https://pf-bp-infra-rbac-service-dev.azurewebsites.net/",
    tenantId: 'be7fd041-b3f2-4a5a-a133-5926db91118e',
    appId: 'clms-uat',
    auth0: {
        domain: "bluepond-dev.us.auth0.com",
        clientId: "L2bcf5MVdhN26JM5kP8bBilV5JefBpqY",
        audience: "bp-platform-dev.ai"
    },
    mclFeatures: false,
};
